import React from "react";
import { createRoot } from 'react-dom/client';
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: {
            en: {
                translation: {
                    "title": "I'm 28 years old. I have 2 loves that is technology and games.",
                    "hi": "Hi",
                    "im_willian": "I'm Willian",
                    "fullstack_developer": "Fullstack Developer",

                    "home": "Home",
                    "about": "About",
                    "project": "Projects",
                    "contact": "Contact",
                    
                    "learn_more": "Learn More",
                    "about_me": "About Me",
                    "about_me_1": "I am Fullstack Developer",
                    "about_me_2": "My name is Willian Almeida Buqui I'm 28 years old and I've been working with system development for +7 years , I've worked for some big companies like IBM, Santander and Itau. Today I work at a startup focused on the energy sector. I have a bachelor of computer science and working with node.js and GoLang in backend and front with React.js. My best experiences are with node.js,GoLang, .net, Docker, AWS, Linux, MySQL, Jenkins, React.js e Angular 2+. At the moment I'm studying clean architecture, microservices with golang and with studies focused on CI/CD to automate deploy with jenkins using container architecture",
                    "about_me_3": "I use React to create my applications and with it redux to manage states. This portfolio was created in react and tailwind and can be accessed at the link.",
                    "about_me_4": "Today my Stack is focused on using the golang tool, because its speed and performance caught my attention, but I have knowledge in creating a backend in nodejs and .net.",
                    "about_me_5": "Knowledge to manage an AWS account using the main tools being them EC2, cloudfront, s3, RDS, Route 53 and GuardDuty. I have knowledge to create docker for upload database and applications using the same network.",
                
                    "articles_projects": "Articles/Projects",
                    "project_1": "Some projects and articles that are to help the community",
                    "project_2": "A/B test react.js with nginx and docker.",
                    "project_3": "In this article, we'll see how to do an A/B Test using nginx to balance and docker to upload applications, each one in its respective container.",
                    
                    "project_4": "Creating your portfolio and publishing to AWS.",
                    "project_5": "In this article I will help you create your first portfolio using React with tailwind and host it on aws with s3 and Cloudfront.",

                    

                    "contact": "Contact",
                    "contact_1": "Get In",
                    "contact_2": "Touch",
                    "contact_3": "Name",
                    "contact_4": "Last Name",
                    "contact_5": "Email Address",
                    "contact_6": "Your Message",
                    "contact_7": "Send Message",
                    
                    "footer_1": "Resources",
                    "footer_2": "Support",
                    "footer_3": "Contact us", 
                    "footer_4": "Resume", 
                    "footer_5": "All Rights Reserved", 
                    "footer_6": "Copyright", 
                    

                }
            },
            br: {
                translation: {
                    "title": "Eu tenho 28 anos. Tenho 2 amores tecnologia e Video game.",
                    "hi": "Oi",
                    "im_willian": "eu sou o Willian",
                    "fullstack_developer": "Desenvolvedor Fullstack",

                    "home": "Home",
                    "about": "Sobre",
                    "project": "Projetos",
                    "contact": "Contato",

                    "learn_more": "Saber mais",
                    "about_me": "Sobre mim",
                    "about_me_1": "Sou Desenvolvedor Fullstack",
                    "about_me_2": "Meu nome é Willian Almeida Buqui tenho 28 anos e trabalho com desenvolvimento de sistemas há +7 anos, já trabalhei para grandes empresas como IBM, Santander e Itaú. Hoje trabalho em uma startup focada no setor de energia. Sou bacharel em ciência da computação e trabalho com node.js e GoLang no back-end e front-end com o React.js. Minhas melhores experiências são com node.js,GoLang, .net, Docker, AWS, Linux, MySQL, Jenkins, React.js e Angular 2+. No momento estou estudando arquitetura limpa, microsserviços com golang e com estudos focados em CI/CD para automatizar o deploy com jenkins usando arquitetura container",
                    "about_me_3": "Eu uso React para criar meus aplicativos e com ele redux para gerenciar estados. Este portfólio foi criado no react e tailwind e pode ser acessado no link.",
                    "about_me_4": "Hoje meu Stack é focado em utilizar a ferramenta golang, pois sua velocidade e performance me chamaram a atenção, mas possuo conhecimento em criação de backend em nodejs e .net.",
                    "about_me_5": "Conhecimento para gerenciar uma conta AWS utilizando as principais ferramentas sendo elas EC2, cloudfront, s3, RDS, Route 53 e GuardDuty. Tenho conhecimento para criar docker para upload de banco de dados e aplicativos usando a mesma rede.",


                    "articles_projects": "Artigos/Projetos",
                    "project_1": "Alguns projetos e artigos que visam ajudar a comunidade",
                    "project_2": "Teste A/B react.js com nginx e docker.",
                    "project_3": "Neste artigo, veremos como fazer um Teste A/B usando nginx para balancear e docker para carregar aplicações, cada uma em seu respectivo container.",
                    
                    "project_4": "Criando seu portifolio e publicando no AWS.",
                    "project_5": "Nesse artigo vou te ajudar a criar seu primeiro portfólio utilizando React com tailwind e hospedar no aws com s3 e Cloudfront.",


                    "contact": "Contato",
                    "contact_1": "Entre em",
                    "contact_2": "contato",
                    "contact_3": "Nome",
                    "contact_4": "Ultimo nome",
                    "contact_5": "Endereço de email",
                    "contact_6": "Sua mensagem",
                    "contact_7": "Enviar mensagem",


                    "footer_1": "Recurso",
                    "footer_2": "Suporte",
                    "footer_3": "Contate-nos",
                    "footer_4": "Curriculo", 
                    "footer_5": "Criado e desenvolvido por", 
                    "footer_6": "Todos direitos reservados", 

                    

                    
                }
            }
        },
        lng: "en",
        fallbackLng: "en",

        interpolation: {
            escapeValue: false
        }
    });

